/**
 * digitalLeadVerificationApi.js — axios service layer for OTP work flow
 *
 * Matches the pattern of your existing api.js (fetchFunnelBySite, sendAdDetails etc.)
 * Replace `api` with your existing axios instance if you have one.
 */
import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  timeout: 10_000,
  headers: { "Content-Type": "application/json" }
});

// ── OTP ───────────────────────────────────────────────────────────────────────

export const sendOtp = async (leadId, phone) => {
  const { data } = await api.post("/digital-lead-verification/send-otp", {
    leadId,
    phone
  });
  return data; // { success, fallbackAt, resendAvailableAt }
};

export const verifyOtp = async (leadId, code) => {
  const { data } = await api.post("/digital-lead-verification/verify-otp", {
    leadId,
    code
  });
  return data;
};

export const resendOtp = async (leadId, newPhone = null) => {
  const { data } = await api.post("/digital-lead-verification/resend-otp", {
    leadId,
    ...(newPhone ? { newPhone } : {})
  });
  return data; // { resendAvailableAt }
};

export const manualFallback = async (leadId) => {
  const { data } = await api.post(
    "/digital-lead-verification/manual-fallback",
    { leadId }
  );
  return data;
};

export const getSessionStatus = async (leadId) => {
  const { data } = await api.get("/digital-lead-verification/session-status", {
    params: { leadId }
  });
  return data; // { expired, fallbackAt }
};

export const submitAvailability = async (leadId, optimalAvailability) => {
  const { data } = await api.post(
    "/digital-lead-verification/submit-availability",
    { leadId, optimalAvailability }
  );
  return data;
};
